import { ContactHero } from "../components/contact/ContactHero";
import { ContactForm } from "../components/contact/ContactForm";
import { ContactDetails } from "../components/contact/ContactDetails";
import { Seo } from "../components/Seo";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="bg-deepred pb-10 sm:pb-16">
      <Seo
        title="Contact & Location"
        description="Find Chicken Labb at 1216 Main Ave, New Jersey. Call 908 333 6363, get directions, or send us a message. Open Mon–Sun, 11:00–23:00."
        path="/contact"
      />
      <ContactHero />
      <section className="py-4 sm:py-6">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-6 px-6 sm:px-10 lg:grid-cols-2">
          <ContactForm />
          <ContactDetails />
        </div>
      </section>
    </main>
  );
}
